export function FileGalleryEmptyState() {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="text-center">
        <p className="text-sm text-ink-600">No files found</p>
        <p className="mt-1 text-xs text-ink-500">
          Try adjusting your filters or upload new files
        </p>
      </div>
    </div>
  );
}

